import { getOrganizations, OrganizationFilterParameters } from '../../api/organizations';
import { Organization } from '../../interfaces/api/organization';

export async function fetchOrganizations(
	params: OrganizationFilterParameters
): Promise<Organization[]> {
	try {
		return await getOrganizations(params);
	} catch (error) {
		throw error;
	}
}
